import { push } from 'react-router-redux';

import * as AccountRepository from 'repositories/account';

import { AccountActionCreators, resetTempAccount } from 'actions/account';
import { FlashMessageActionCreators } from 'actions/flashMessage';
import { LayoutActionCreators } from 'actions/layout';
import { request } from 'actions/otp';
import { ROUTE_ACCOUNT_GET_STARTED, ROUTE_ACCOUNT_PHONE_SET_OTP } from 'constants/app';
import { handleGenericApiError } from 'helper/error';
import { AccountPhoneForm, AccountPhoneOtpForm, TempAccount } from 'models/account';
import { Thunk } from 'models/redux';

export function confirmPhone(formValue: AccountPhoneOtpForm): Thunk {
  return (dispatch) => {
    dispatch(LayoutActionCreators.showLoading.create());

    AccountRepository.confirmPhone(formValue)
      .then(() => {
        dispatch(resetTempAccount());
        dispatch(push(ROUTE_ACCOUNT_GET_STARTED));
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'success',
          text: 'action.success.otp.account.phone.setnumber'
        }));
        dispatch(LayoutActionCreators.hideLoading.create());
      })
      .catch((e) => {
        handleGenericApiError('action.failed.otp.confirm', e, dispatch);
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}

export function validatePhone(formValue: AccountPhoneForm): Thunk {
  return (dispatch) => {
    dispatch(LayoutActionCreators.showLoading.create());

    AccountRepository.validatePhone(formValue)
      .then((account) => {
        const { phone } = formValue;
        const tempAccount: TempAccount = { email: '', password: '', phone };
        dispatch(AccountActionCreators.updateTempAccount.create(tempAccount));
        dispatch(request(phone));
        dispatch(push(ROUTE_ACCOUNT_PHONE_SET_OTP));
        dispatch(LayoutActionCreators.hideLoading.create());
      })
      .catch((e) => {
        handleGenericApiError('action.failed.account.validate.set.phonenumber', e, dispatch);
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/account/phone.ts